import PropTypes from 'prop-types';
import React from 'react';
import referralCodes from 'referral-codes';

import AuthUserContext from './context';
import Config from '../../config';
import { withFirebase } from '../../firebase';

const AuthenticationProvider = ({ children, firebase }) => {
  const firebaseUserListener = React.useRef(null);
  const unsubscribeFromUserUpdates = React.useRef(null);

  const [authUser, setAuthUser] = React.useState(null);
  const [ready, setReady] = React.useState(false);

  const getFullPassMeta = (user) => {
    if (!user) {
      return {};
    }

    return {
      isFullPassActive: !!user && !!user.fullPass && new Date(user.fullPass.nextDate) >= new Date(),
      isFullPassGift: !!user && !!user.fullPass && !!user.fullPass.isGift,
      hasAClass: !!user.classes && !!user.classes.available && user.classes.available.length > 0,
    };
  };

  React.useEffect(() => {
    if (firebase && !firebaseUserListener.current) {
      firebaseUserListener.current = firebase.auth.onAuthStateChanged(async (autenticationhUser) => {
        console.log('withAuthentication got user', autenticationhUser);

        if (!autenticationhUser?.uid) {
          if (unsubscribeFromUserUpdates.current) {
            unsubscribeFromUserUpdates.current();
            window.dataLayer.push({
              event: 'userLoggedOut',
              email: null,
            });
          }

          localStorage.removeItem('user');

          setAuthUser(null);
          setReady(true);
        } else {

          window.dataLayer.push({
            event: 'userLoggedIn',
            email: autenticationhUser.email,
          });

          /* const getUserFromLocalStorage = async () => localStorage.getItem('user');

          // this is breaking authentication flow
          // firebase.user(authUser.uid).set({ lang }, { merge: true });

          getUserFromLocalStorage().then((localStorageUser) => {
            if (localStorageUser) {
              setAuthUser({
                ...autenticationhUser,
                ...JSON.parse(localStorageUser),
                ...getFullPassMeta(localStorageUser),
              });
            }
          }); */

          unsubscribeFromUserUpdates.current = firebase.user(autenticationhUser.uid).onSnapshot(async (userSnap) => {
            const user = userSnap.data();
            const userRef = firebase.user(userSnap.id);

            console.log('AuthenticationProvicer : user', user);

            if (user) {
              if (!user.exists) {
                await firebase.user(autenticationhUser.uid).set({
                  newsletter: true,
                  email: autenticationhUser.email,
                }, { merge: true });
              }

              if (!user.referralCode) {
                userRef.set({ referralCode: referralCodes.generate({ length: 12 })[0] }, { merge: true });
              }

              /* localStorage.setItem('user', JSON.stringify({
                ...user,
                ...getFullPassMeta(user),
              })); */

              const userToSet = {
                ...autenticationhUser,
                ...user,
                ...getFullPassMeta(user),
              };

              setAuthUser(userToSet);
              setReady(true);
            }
          });

          fetch(`${Config.parseServer.apiUrl}/log-auth`, {
            method: 'POST',
            body: JSON.stringify({
              uid: autenticationhUser.uid,
              event: 'connect',
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          });
        }
      });
    }

    return () => {
      if (firebaseUserListener.current) {
        firebaseUserListener.current();
      }

      if (unsubscribeFromUserUpdates.current) {
        unsubscribeFromUserUpdates.current();
      }
    };
  }, [firebase]);

  return (
    <AuthUserContext.Provider value={{ authUser, isAuthReady: ready }}>
      {children}
    </AuthUserContext.Provider>
  );
};

AuthenticationProvider.propTypes = {
  children: PropTypes.any,
  firebase: PropTypes.any,
};

AuthenticationProvider.defaultProps = {
  children: null,
  firebase: null,
};

export default withFirebase(AuthenticationProvider);
